module.exports = __webpack_public_path__ + "warning.svg?05cc42340f158cb3fe282d439287ca0d";